var _defs, _g, _g2, _rect, _rect2, _circle, _polyline, _line, _rect3, _rect4, _circle2, _polyline2, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductCluster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178 123.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130,34.46v46.79c0,.27-.13.53-.34.66l-37.09,23.49c-.3.18-.54.07-.67,0-.16-.1-.33-.29-.33-.66v-46.79c0-.27.13-.52.34-.65l36.7-23.25.4-.25c.12-.07.23-.1.33-.1.13,0,.25.05.34.11.12.08.33.28.33.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.98,34.77v46.79c0,.27.13.53.34.66l37.09,23.49c.3.18.54.07.67,0,.16-.1.33-.29.33-.66v-46.79c0-.27-.13-.52-.34-.65l-36.7-23.25-.4-.25c-.12-.07-.23-.1-.33-.1-.13,0-.25.05-.34.11-.12.08-.33.28-.33.66Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.59,5.72l14.46,8.78-38.26,24.23-13.66-8.29c-.32-.2-.37-.53-.38-.71,0-.18.05-.51.37-.71L88.92,5.73c.1-.07.22-.1.34-.1.11,0,.23.03.33.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.7,28.71c0,.18-.05.51-.37.71l-36.7,23.24-.08.05c-.21.13-.47.14-.68,0l-18.18-11.03,38.26-24.23,17.38,10.54c.32.2.37.53.38.71Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.61,
    y: 0,
    width: 20.92,
    height: 20.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.61,
    y: 102.63,
    width: 20.92,
    height: 20.92
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.42,
    cy: 63.41,
    r: 12.42
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "17.56 15.82 31.89 29.95 31.89 95.98 17.65 110.47"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.52,
    y1: 62.26,
    x2: 43.65,
    y2: 62.26
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 154.47,
    y: 0,
    width: 20.92,
    height: 20.92,
    transform: "translate(329.85 20.92) rotate(-180)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 154.47,
    y: 102.63,
    width: 20.92,
    height: 20.92,
    transform: "translate(329.85 226.17) rotate(-180)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 165.58,
    cy: 63.41,
    r: 12.42
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "160.44 15.82 146.11 29.95 146.11 95.98 160.35 110.47"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.48,
    y1: 62.26,
    x2: 134.35,
    y2: 62.26
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCluster);
export default __webpack_public_path__ + "static/media/ProductCluster.d919c0c38577baafa374bc7a01605b57.svg";
export { ForwardRef as ReactComponent };